module.exports = __webpack_public_path__ + "static/media/bk_chart.9a9c2109.svg";